import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-cookies-policy-view',
    templateUrl: './cookies-policy-view.component.html',
    styleUrls: ['./cookies-policy-view.component.scss'],
    standalone: false
})
export class CookiesPolicyViewComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
